import { Badge, Button } from "@dealer-center/core-components";
import {
  BadgeSX,
  StyledCloseButton,
  StyledPagesClientSearchSearchPills
} from "./styles";
import type { PagesClientSearchSearchPillsProps } from "./types";
import {
  itemIsComplexMatchSpecDealerCodeSpec,
  itemIsComplexMatchSpecString,
  itemIsDateRange
} from "./types";

export const PagesClientSearchSearchPills = ({
  items,
  label,
  mappingKey,
  onClick: onClickProp
}: PagesClientSearchSearchPillsProps) => {
  if (!items) return null;

  const onClick = (value?: string | number) => {
    onClickProp(value || "", mappingKey);
  };

  if (Array.isArray(items)) {
    return (
      <StyledPagesClientSearchSearchPills>
        {items.map(value => (
          <Button
            analyticsConfiguration={{
              eventName: "Client Search Pill Clicked"
            }}
            buttonStyle="aux"
            key={value}
            onClick={() => onClick(value)}
          >
            <Badge sx={BadgeSX} variant="info">
              {label}: {value}
              <StyledCloseButton title="Clear client search" />
            </Badge>
          </Button>
        ))}
      </StyledPagesClientSearchSearchPills>
    );
  }

  if (itemIsComplexMatchSpecString(items)) {
    return (
      <StyledPagesClientSearchSearchPills>
        {items.matchAny?.map(value => (
          <Button
            analyticsConfiguration={{
              eventName: "Client Search matchAny Pill Clicked"
            }}
            buttonStyle="aux"
            key={value}
            onClick={() => onClick(value)}
          >
            <Badge sx={BadgeSX} variant="info">
              {label} any: {value}
              <StyledCloseButton title="Clear client search matchAny" />
            </Badge>
          </Button>
        ))}

        {items.matchAll?.map(value => (
          <Button
            analyticsConfiguration={{
              eventName: "Client Search matchAll Pill Clicked"
            }}
            buttonStyle="aux"
            key={value}
            onClick={() => onClick(value)}
          >
            <Badge sx={BadgeSX} variant="info">
              {label} all: {value}
              <StyledCloseButton title="Clear client search matchAll" />
            </Badge>
          </Button>
        ))}

        {items.matchNone?.map(value => (
          <Button
            analyticsConfiguration={{
              eventName: "Client Search matchNone Pill Clicked"
            }}
            buttonStyle="aux"
            key={value}
            onClick={() => onClick(value)}
          >
            <Badge sx={BadgeSX} variant="info">
              {label} none: {value}
              <StyledCloseButton title="Clear client search matchNone" />
            </Badge>
          </Button>
        ))}
      </StyledPagesClientSearchSearchPills>
    );
  }
  if (itemIsComplexMatchSpecDealerCodeSpec(items)) {
    return (
      <StyledPagesClientSearchSearchPills>
        {items.matchAll?.map(value => (
          <Button
            analyticsConfiguration={{
              eventName: "Client Search Dealer Code Pill Clicked"
            }}
            buttonStyle="aux"
            key={value.type}
            onClick={() => onClick(value.type)}
          >
            <Badge sx={BadgeSX} variant="info">
              {label}: {value.type} : {value.codes?.[0]}
              <StyledCloseButton title="Clear client search dealer code" />
            </Badge>
          </Button>
        ))}
      </StyledPagesClientSearchSearchPills>
    );
  }

  if (itemIsDateRange(items)) {
    return (
      <StyledPagesClientSearchSearchPills>
        <Button
          analyticsConfiguration={{
            eventName: "Date Range Clicked"
          }}
          buttonStyle="aux"
          onClick={() => onClick()}
        >
          <Badge sx={BadgeSX} variant="info">
            {label}:<br /> {items.after} - {items.before}
            <StyledCloseButton title="Clear Date Range" />
          </Badge>
        </Button>
      </StyledPagesClientSearchSearchPills>
    );
  }
  return null;
};
